import { Outlet } from "react-router-dom";

export default function Users() {
	return (
		<div className='rooms-page page'>
			<Outlet />
		</div>
	);
}
